import { isLiveMatch, isPrematch } from '@ms/components/match/status'
import { ALL_SPORTS_MAP } from '@ms/stores/sports/map'
import { prefixLink } from '@ms/config/app'

const encodeName = (val = '') => val && encodeURIComponent(val.replace(/[^a-zA-Z0-9]/g, '_'))

export const getMatchDetailLink = ({ status, sport, sportId, category, tournament, homeTeam, awayTeam, eventId }, linkType = '') => {
  const sportName = sport || ALL_SPORTS_MAP[sportId] || '-'
  const categoryName = encodeName(category)
  const tournamentName = encodeName(tournament)
  const homeTeamName = encodeName(homeTeam)
  const awayTeamName = encodeName(awayTeam)

  const ctName = `${categoryName}_${tournamentName}`
  const haName = `${homeTeamName}_vs_${awayTeamName}`

  const isLive = isLiveMatch(status)
  let link = ''
  if (isLive) {
    // live 详情
    link = `/sports/${sportName}/live/${ctName}/${haName}/${eventId}`
  } else if (isPrematch(status)) {
    // preMatch 详情
    link = `/sports/${sportName}/${ctName}/${haName}/${eventId}`
  } else {
    // result 详情
    link = `/sports/result/${sportName}/${ctName}/${haName}/${eventId}`
  }

  if (linkType === 'href') {
    return prefixLink(link)
  }

  return link
}
